import {Job} from '../../../../shared/utils'

// Service names written for OmicsAI agent activity (AI chat billing defaults to "OmicsBoxAI").
const OMICS_AI_SERVICE_PREFIXES = ['omicsboxai', 'omicsai']

const normalizeServiceName = (name: string) => name.toLowerCase().replace(/[\s_-]+/g, '')

export const isOmicsAIJob = (job: Pick<Job, 'serviceName'> | null | undefined): boolean => {
  const serviceName = job?.serviceName
  if (typeof serviceName !== 'string' || serviceName === '') return false
  const normalized = normalizeServiceName(serviceName)
  return OMICS_AI_SERVICE_PREFIXES.some((prefix) => normalized.startsWith(prefix))
}

export const filterJobsByOmicsAI = <T extends Pick<Job, 'serviceName'>>(
  jobs: T[] | undefined,
  showOmicsAI: boolean
): T[] | undefined => {
  if (!jobs || showOmicsAI) return jobs
  return jobs.filter((job) => !isOmicsAIJob(job))
}

const SHOW_OMICS_AI_STORAGE_KEY = 'job-history-show-omicsai'

export const loadShowOmicsAI = (): boolean => {
  try {
    return localStorage.getItem(SHOW_OMICS_AI_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const saveShowOmicsAI = (value: boolean): void => {
  try {
    localStorage.setItem(SHOW_OMICS_AI_STORAGE_KEY, value ? 'true' : 'false')
  } catch {
    // Storage unavailable (private mode / blocked); the toggle still works for this session.
  }
}
